/**
 * ScoutView.jsx - Player selection view
 * Phase 3B Round 2 - Named export only
 * 
 * Extracted from GMRosterBuilderV2.jsx lines 434-471
 */

import React from 'react';
import { ChevronLeft } from 'lucide-react';
import FilterBar from '../../../components/builder/FilterBar';
import ScoutPlayerCard from '../../../components/builder/ScoutPlayerCard';

export const ScoutView = ({
  activeSlot,
  filteredPlayers,
  filters,
  onFiltersChange,
  onSelectPlayer,
  onBack,
}) => {
  return (
    <div className="min-h-screen bg-slate-100 flex flex-col pb-16">
      <header className="bg-white shadow-sm sticky top-0 z-10">
        <div className="flex items-center justify-between px-3 py-2">
          <button 
            onClick={onBack} 
            className="p-1.5 text-slate-600 active:scale-90 min-w-[44px] min-h-[44px] flex items-center justify-center"
          >
            <ChevronLeft size={22} />
          </button>
          <h2 className="text-base font-bold text-slate-900">
            Pick <span className="text-indigo-600">{activeSlot?.label}</span>
          </h2>
          <div className="w-10" />
        </div>
        
        <div className="px-3 pb-2">
          <FilterBar 
            filters={filters} 
            onChange={onFiltersChange}
            slotPosition={activeSlot?.label}
          />
        </div>
      </header>
      
      <main className="flex-1 overflow-y-auto p-3 space-y-2">
        {filteredPlayers.length === 0 ? (
          <div className="text-center py-8 text-slate-500">
            <p className="font-medium">No players found</p>
            <p className="text-sm">Try adjusting your search</p>
          </div>
        ) : (
          filteredPlayers.map(p => (
            <ScoutPlayerCard key={p.id} player={p} onSelect={onSelectPlayer} />
          ))
        )}
      </main>
    </div>
  );
};
